// User data transformer

import { BaseTransformer } from './BaseTransformer';

export class UserTransformer extends BaseTransformer {
  
  async transform(userData: Record<string, unknown>): Promise<Record<string, unknown>> {
    console.log(`[USER-TRANSFORM] Transforming user data for:`, {
      email: userData.email,
      hasId: !!userData.id,
      hasOriginalAmplifyId: !!userData.original_amplify_id,
      id: userData.id, // Log what ID we received
      originalAmplifyId: userData.original_amplify_id
    });
    
    console.log(`[USER-TRANSFORM] Applying user stat mappings`);
    console.log(`   • audioRetentionPeriod → audio_file_retention_days`);
    console.log(`   • transcriptionCreated → total_recordings_created`);
    console.log(`   • currentTranscriptionsCreated → recordings_created`);
    console.log(`   • stripeCustomerId → subscribers.stripe_customer_id`);
    console.log(`   • transcriptionTime → user_usage.total_transcription_seconds`);

    const result: Record<string, unknown> = {
      // No 'id' field - let Edge Function handle user creation properly
      email: userData.email,
      name: userData.name || userData.firstName,
      audio_file_retention_days: this.safeParseInt(userData.audioRetentionPeriod, 30),
      recordings_created: this.safeParseInt(userData.currentTranscriptionsCreated),
      total_recordings_created: this.safeParseInt(userData.transcriptionCreated),
      created_at: userData.createdAt || this.getCurrentTimestamp(),
      updated_at: this.getCurrentTimestamp()
    };

    // Store original Amplify ID for reference if provided
    if (userData.id || userData.original_amplify_id) {
      result.original_amplify_id = userData.original_amplify_id || userData.id;
    }

    // Handle Stripe customer ID separately
    if (userData.stripeCustomerId) {
      result.stripe_customer_data = {
        stripe_customer_id: userData.stripeCustomerId
      };
    }

    // Always include user_usage migration data (even if values are 0)
    const transcriptionTime = this.safeParseFloat(userData.transcriptionTime);
    const totalRecordings = this.safeParseInt(userData.transcriptionCreated);
    const currentRecordings = this.safeParseInt(userData.currentTranscriptionsCreated);
    
    result.user_usage_data = {
      total_recordings_created: totalRecordings,
      total_transcription_seconds: Math.round(transcriptionTime),
      recordings_created: currentRecordings
    };
    console.log(`[USER-TRANSFORM] User usage data: ${totalRecordings} recordings, ${Math.round(transcriptionTime)} seconds`);

    // Handle user preferences data
    if (userData.audioRetentionPeriod || userData.defaultView || userData.preferredLanguage) {
      result.user_preferences_data = {
        audio_file_retention_days: this.safeParseInt(userData.audioRetentionPeriod, 30),
        default_view: userData.defaultView || 'cases',
        preferred_language: userData.preferredLanguage || 'en'
      };
    }

    console.log(`[USER-TRANSFORM] Transformation complete - NO ID field included:`, {
      email: result.email,
      name: result.name,
      originalAmplifyId: result.original_amplify_id,
      hasIdField: 'id' in result,
      keys: Object.keys(result)
    });

    return result;
  }
} 